module.exports = __webpack_public_path__ + "img/fernanda.2c56a8ec.png";